module.exports = __webpack_public_path__ + "img/icon-lab.61353552.png";